export default "__VITE_ASSET__6e030170__"